// @catalog F.047 F.048
// Pantalla /mercado-libre/resumen: economía real mensual del canal Mercado
// Libre. Separada de importaciones y de resultados por pedido (petición del
// propietario 2026-08-21: cada cosa en su pantalla).
import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import { PageHead } from "../components/analytics/PageHead";
import { ResumenMensualBlock } from "../components/MercadoLibre/ResumenMensualBlock";

export function EcommerceResumenMensualPage(): JSX.Element {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={{ p: isMobile ? 2 : 3 }}>
      <Stack spacing={3}>
        <PageHead
          title="Resumen mensual ecommerce"
          subtitle="Economía real del canal Mercado Libre por mes · bruto, comisión, retenciones y márgenes"
        />
        <ResumenMensualBlock />
      </Stack>
    </Box>
  );
}
